import { render, staticRenderFns } from "./HomeJA.vue?vue&type=template&id=a1613e64&scoped=true"
import script from "./HomeJA.vue?vue&type=script&lang=js"
export * from "./HomeJA.vue?vue&type=script&lang=js"
import style0 from "./HomeJA.vue?vue&type=style&index=0&id=a1613e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1613e64",
  null
  
)

export default component.exports